import { isEmpty } from 'lodash';
import CadastrosAdicionais from '@/enums/cadastros-adicionais';
import TiposEntidadeCadastroAdicional from '@/enums/tipos-entidade-cadastro-adicional';

export const replicarCampo = (cadastrosAdicionais, campo) => {
  const { fieldValue } = CadastrosAdicionais.keys[campo.tipo];

  if (!fieldValue) {
    return cadastrosAdicionais;
  }

  if (cadastrosAdicionais[fieldValue]?.id) {
    return cadastrosAdicionais;
  }

  return {
    ...cadastrosAdicionais,
    [fieldValue]: campo,
  };
};

export const replicarCampoProdutos = (produtos, campo) => produtos.map(produto => ({
  ...produto,
  cadastrosAdicionais: replicarCampo(produto.cadastrosAdicionais, campo),
}));

export const getCadastroAdicional = (cadastrosAdicionais, tipo) => {
  if (isEmpty(cadastrosAdicionais)) {
    return null;
  }
  const cadastroAdicional = cadastrosAdicionais.find(c => c.tipo === tipo);
  return cadastroAdicional || null;
};

export const mergeCadastrosAdicionais = (
  firstCadastrosAdicionais,
  secondCadastroAdicionaisProduto,
) => {
  const hasFirst = !isEmpty(firstCadastrosAdicionais);
  const hasSecond = !isEmpty(secondCadastroAdicionaisProduto);

  if (!hasFirst && !hasSecond) return [];
  if (!hasFirst) return secondCadastroAdicionaisProduto;
  if (!hasSecond) return firstCadastrosAdicionais;

  const tiposFirst = firstCadastrosAdicionais.map(ca => ca.tipo);

  return [
    ...firstCadastrosAdicionais,
    ...secondCadastroAdicionaisProduto.filter(ca => !tiposFirst.includes(ca.tipo)),
  ];
};

const extrairCadastrosAdicionaisByType = (cadastrosAdicionais, type) => {
  if (type === TiposEntidadeCadastroAdicional.keys.COMPRA_PRODUTO.key) {
    return [
      cadastrosAdicionais.armazem,
      cadastrosAdicionais.contaContabil,
      cadastrosAdicionais.contaFinanceira,
      cadastrosAdicionais.contaDespesa,
      cadastrosAdicionais.operacao,
      cadastrosAdicionais.segmento,
    ].filter(ca => !!ca?.id);
  }
  if (type === TiposEntidadeCadastroAdicional.keys.REQUISICAO_PRODUTO.key) {
    return [
      cadastrosAdicionais.armazem,
      cadastrosAdicionais.contaContabil,
      cadastrosAdicionais.contaDespesa,
      cadastrosAdicionais.operacao,
      cadastrosAdicionais.contaFinanceira,
      cadastrosAdicionais.segmento,
    ].filter(ca => !!ca?.id);
  }
  if (type === TiposEntidadeCadastroAdicional.keys.COTACAO_PRODUTO.key) {
    return [
      cadastrosAdicionais.contaDespesa,
      cadastrosAdicionais.contaFinanceira,
    ].filter(ca => !!ca?.id);
  }
  if (type === TiposEntidadeCadastroAdicional.keys.COMPRA.key) {
    return [
      cadastrosAdicionais.natureza,
      cadastrosAdicionais.condicaoPagamento,
      cadastrosAdicionais.tipoCobranca,
      cadastrosAdicionais.observacaoInterna,
      cadastrosAdicionais.tipoCompra,
      cadastrosAdicionais.operacao,
      cadastrosAdicionais.contaFinanceira,
    ].filter(ca => !!ca?.id);
  }
  if (type === TiposEntidadeCadastroAdicional.keys.FORNECEDOR.key) {
    return [
      cadastrosAdicionais.natureza,
    ].filter(ca => !!ca?.id);
  }
  if (type === TiposEntidadeCadastroAdicional.keys.REQUISICAO.key) {
    return [
      cadastrosAdicionais.natureza,
    ].filter(ca => !!ca?.id);
  }
  return [];
};

export const extrairCadastrosAdicionais = (cadastrosAdicionais, type) => {
  if (!cadastrosAdicionais) {
    return [];
  }
  if (typeof cadastrosAdicionais === 'object') {
    return extrairCadastrosAdicionaisByType(cadastrosAdicionais, type);
  }

  return cadastrosAdicionais ?? [];
};

export const buildCadastrosAdicionaisPayload = (cadastrosAdicionais, type) => {
  if (!cadastrosAdicionais) {
    return [];
  }
  if (typeof cadastrosAdicionais === 'object') {
    return extrairCadastrosAdicionaisByType(
      cadastrosAdicionais,
      type,
    ).map(ca => ({ id: ca.id }));
  }

  return cadastrosAdicionais.map(ca => ({ id: ca.id })) ?? [];
};

/**
 * Constroi um array com as chaves dos cadastros adicionais
 *
 * @param {Object|Array} cadastrosAdicionais
 * @returns {string[]}
 */
const buildCadastrosAdicionaisKeys = (cadastrosAdicionais) => {
  if (cadastrosAdicionais.length > 0) {
    return cadastrosAdicionais.map(ca => ca.tipo);
  }
  if (typeof cadastrosAdicionais === 'object') {
    return Object.keys(cadastrosAdicionais);
  }
  return [];
};


/**
 * Verifica se dois conjuntos de cadastros adicionais possuem as mesmas
 * chaves.
 *
 * @param {Object|Array} cadastrosAdicionais1
 * @param {Object|Array} cadastrosAdicionais2
 * @returns {boolean}
 */
export const cadastrosAdicionaisHasSameKeys = (cadastrosAdicionais1, cadastrosAdicionais2) => {
  if (!cadastrosAdicionais1 || !cadastrosAdicionais2) {
    return false;
  }

  const cadastrosKeys1 = buildCadastrosAdicionaisKeys(cadastrosAdicionais1);
  const cadastrosKeys2 = buildCadastrosAdicionaisKeys(cadastrosAdicionais2);

  const hasSameLength = cadastrosKeys1.length === cadastrosKeys2.length;

  return hasSameLength ? cadastrosKeys1.every(key => cadastrosKeys2.includes(key)) : false;
};
